// AppRoute.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import About from './pages/About';
import Pastor from './pages/Pastor';
import Schedule from './pages/Schedule';
import BibleStudyMaterials from './pages/BibleStudyMaterials';
import BibleStudyMaterial from './pages/BibleStudyMaterial';
import PastorMessages from './pages/PastorMessages';
import PastorMessage from './pages/PastorMessage';
import SermonMessages from './pages/SermonMessages';
import SermonMessage from './pages/SermonMessage';
import Testimonies from './pages/Testimonies';
import Testimony from './pages/Testimony';
import Articles from './pages/Articles';
import Article from './pages/Article';
import Contact from './pages/Contact';
import ChurchMedia from './pages/ChurchMedia';
import LogIn from './pages/LogIn';
import LogOut from './pages/LogOut';
import Register from './pages/Register';
import Profile from './pages/Profile';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminTablePage from './pages/admin/AdminTablePage';
import AddRecord from './pages/admin/AddRecord';
import EditRecord from './pages/admin/EditRecord';
import ProtectedRoute from './components/ProtectedRoute';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import NotFound from './pages/NotFound';

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/about/pastor/:name" element={<Pastor />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/bible-study-materials" element={<BibleStudyMaterials />} />
            <Route path="/bible-study-materials/read/:id" element={<BibleStudyMaterial />} />
            <Route path="/pastor-messages" element={<PastorMessages />} />
            <Route path="/pastor-messages/read/:id" element={<PastorMessage />} />
            <Route path="/sermon-messages" element={<SermonMessages />} />
            <Route path="/sermon-messages/read/:id" element={<SermonMessage />} />
            <Route path="/testimonies" element={<Testimonies />} />
            <Route path="/testimonies/read/:id" element={<Testimony />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/read/:id" element={<Article />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/church-media" element={<ChurchMedia />} />
            <Route path="/login" element={<LogIn />} />
            <Route path="/logout" element={<LogOut />} />
            <Route path="/register" element={<Register />} />
            <Route path="/profile" element={
                    <ProtectedRoute requiredLevel={1}>
                        <Profile />
                    </ProtectedRoute>
                }
            />
            <Route path="/admin" element={
                    <ProtectedRoute requiredLevel={1}>
                        <AdminDashboard />
                    </ProtectedRoute>
                }
            />
            <Route path="/admin/:tableName" element={
                    <ProtectedRoute requiredLevel={1}>
                        <AdminTablePage />
                    </ProtectedRoute>
                }
            />
            <Route path="/admin/:tableName/add" element={
                    <ProtectedRoute requiredLevel={1}>
                        <AddRecord />
                    </ProtectedRoute>
                }
            />
            <Route path="/admin/:tableName/edit/:submission_id" element={
                    <ProtectedRoute requiredLevel={1}>
                        <EditRecord />
                    </ProtectedRoute>
                }
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

export default AppRoutes;
